<template>
  <el-select
    :model-value="normalized"
    multiple
    filterable
    collapse-tags
    collapse-tags-tooltip
    :placeholder="placeholder"
    :loading="loading"
    :disabled="disabled"
    style="width: 100%"
    @update:model-value="onChange"
  >
    <el-option
      v-for="tag in tags"
      :key="tag.tagId"
      :label="tag.name"
      :value="tag.tagId"
    />
  </el-select>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContentTagSelect',
  props: {
    modelValue: { type: Array, default: () => [] },
    scope: { type: String, required: true },
    placeholder: { type: String, default: '请选择标签（可多选）' },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      loading: false,
      tags: []
    }
  },
  computed: {
    normalized() {
      return (this.modelValue || []).map((id) => Number(id)).filter((id) => id > 0)
    }
  },
  watch: {
    scope: {
      immediate: true,
      handler() {
        this.loadTags()
      }
    }
  },
  methods: {
    onChange(ids) {
      this.$emit(
        'update:modelValue',
        (ids || []).map((id) => Number(id)).filter((id) => id > 0)
      )
    },
    async loadTags() {
      if (!this.scope) {
        this.tags = []
        return
      }
      this.loading = true
      try {
        const response = await axios.post('/api/v1/content/tag/list', {
          scope: this.scope,
          recommendedOnly: 0
        })
        if (response.data?.code === 200) {
          this.tags = response.data.data?.tags || []
        } else {
          this.tags = []
        }
      } catch {
        this.tags = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
